<template>
  <div class="slots">
    <van-popup v-model="showPop" round :style="{width:'80%'}" :close-on-click-overlay="false" get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          input-align="right"
          ref="form"
        >
          <van-field
            required
            readonly
            :disabled="from == 'manager' && !drawLots.isNewAdd"
            clickable
            right-icon="arrow"
            v-model="drawLots.typeName"
            label="签类型"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择签类型' }]"
            @click="changePicker(1)"
          />
          <!-- <van-field
            required
            readonly
            clickable
            right-icon="arrow"
            v-model="drawLots.drawLotsDesc"
            label="签语"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择签语' }]"
            @click="changePicker(2)"
          /> -->
          <template v-if="drawLots.type == 'definition'">
            <van-field required  label="签图">
              <template #input>
                <van-uploader
                  :max-count="1" 
                  :before-read="beforeImgUpload" 
                  :fileList="drawLots.imgList" 
                  :after-read="uploadImg"
                  @delete="deleteImg"
                />
              </template>
            </van-field>
            <van-field
              required
              v-model="drawLots.definitionTitle"
              maxlength="3"
              label="签标题"
              placeholder="请输入"
              :rules="[{ required: true, message: '请输入签标题' }]"
              :formatter="formatter"
            />
          </template>
          <van-field
            required
            right-icon="arrow"
            type="digit"
            v-model="drawLots.drawLotsNumber"
            label="数量"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入数量' }]"
            @blur="checkFeeValid('drawLotsNumber')"
          >
            <span slot="right-icon">份</span>
          </van-field>
          <div class="tips">表示当前签最大可发放量</div>
           <van-field
            v-if="from == 'manager' && !drawLots.isNewAdd"
            disabled
            right-icon="arrow"
            type="digit"
            v-model="drawLots.soldNumber"
            label="已领取"
            placeholder="请输入"
          >
            <span slot="right-icon">份</span>
          </van-field>
          <van-field
            required
            type="number"
            right-icon="arrow"
            v-model="drawLots.drawLotsProb"
            label="获得概率"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入获得概率' }]"
            @blur="checkFeeValid('drawLotsProb')"
          >
            <span slot="right-icon">%</span>
          </van-field>
          <div class="tips">表示在有数量的情况下，获得该签的概率</div>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="cancel">取消</div>
          <div class="button" @click="submit">
            {{from == 'manager' ? '保存并上架' : '保存'}}
          </div>
        </div>
         <div style="height:66px"></div>
      </div>
    </van-popup>
    <van-popup v-model="isPicker" position="bottom" get-container="body" >
      <van-picker
        value-key="dictDataValue"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <div class="h5-cropper">
      <h5-cropper ref="cropper" :option="option" @getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
    </div>
  </div>
</template>

<script>
import H5Cropper  from 'vue-cropper-h5'
import { round2Places } from "@/utils/utils";
export default {
  components: {
    H5Cropper
  },
  props: {
    isAddDrawsotsPop: {
      type: Boolean,
      default: false
    },
    drawLots: {
      type: Object,
      default() {
        return {}
      }
    },
    allDrawLots: {
      type: Array,
      default() {
        return []
      }
    },
    defaultPhoneHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      drawLotstype: [],
      drawLotsDesc: [],
      isPicker: false,
      isUploadImg: false,
      option: {
        ceilbutton: true,
        fixed: false,
        autoCropWidth: 215,
        autoCropHeight: 181
      },
      headImgList: [],
      columns: [],
      isClike: true
    }
  },
  computed: {
    showPop: {
      get() {
        return this.isAddDrawsotsPop
      },
      set(val) {
        this.$emit('update:isAddDrawsotsPop', val)
      }
    },
    from() {
      return this.$route.query.from
    }
  },
  methods: {
    formatter(value) {
      return value.replace(" ","")
    },
    changePicker(type) {
      if (type == 1 && this.from == 'manager' && !this.drawLots.isNewAdd){
        return
      }
      this.changeType = type
      // 1签类型 2签语
      switch(type) {
        case 1 :
          this.columns = this.drawLotstype
          break
        case 2 :
          this.columns = this.drawLotsDesc
          break
      }
      this.isPicker = true
    },
    onConfirm(value) {
      const { dictDataValue,dictDataCode,extendField,dataDesc=''} = value
      if (this.changeType == 1) {
        this.drawLots.type = dictDataCode
        this.drawLots.typeName = dictDataValue
        this.drawLots.img = dataDesc
        this.drawLots.drawLotsDesc = extendField
      }else if (this.changeType == 2) {
        this.drawLots.drawLotsDesc = dictDataValue
      }
      this.isPicker = false
    },
    onCancel() {
      this.isPicker = false
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e) {
      this.$emit("changFoot", false)
      this.$refs.cropper.loadFile(e.file)
      this.showPop = false
    },
    getFile(file) {
      this.$emit("changFoot", true)
      this.showPop = true
      this.isUploadImg = true
      const currentFile = {
        url: '',
        status:'uploading',
        message: '上传中...'
      }
      this.drawLots.imgList.push(currentFile)
      this.$api.common.uploadImg(file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            currentFile.url = fileUrl
            currentFile.status = 'done'
            delete this.drawLots.imgList[0].status
            delete this.drawLots.imgList[0].message
            this.isUploadImg = false
          }
        })
        .catch(err => {
          this.isUploadImg = false
          this.drawLots.imgList = []
      });
    },
    deleteImg() {
      this.drawLots.imgList = []
    },
    canceltailor() {
      this.showPop = true
      this.$emit("changFoot", true)
    },
    checkFeeValid(fieldName) {
      let parame = this.drawLots[fieldName]
      this.drawLots[fieldName] = round2Places(parame)
      if (fieldName == 'drawLotsNumber' && parame > 999999) {
        this.drawLots[fieldName] = 999999
        return
      }
      if (fieldName == 'drawLotsProb') {
        if (parame > 100) {
          this.drawLots[fieldName] = 100
        }else if(parame < 0) {
          this.drawLots[fieldName] = 0
        }
      }
    },
    submit() {
      // 图片上传中
      if (this.isUploadImg) return
      if (this.drawLots.type == 'definition') {
        if (!this.drawLots.imgList.length) {
          this.$toast('请上传签图');
          return
        }else {
          this.drawLots.img = this.drawLots.imgList[0].url
        }
      }
      if (this.isClike) {
        this.isClike = false
        this.$refs.form.validate().then(async res => {
          let result = this.allDrawLots.some(item => item == this.drawLots.typeName)
          if (result) {
            this.$toast(`${this.drawLots.typeName}已经存在`);
            this.isClike = true
            return 
          }
          if (this.from == 'manager') {
            const res = await this.$api.drawlots.saveDrawLotsAndOnline(this.drawLots).finally(err => {
              this.isClike = true
            })
            this.drawLots.status = 0
            if (res.data) {
              this.drawLots.id = res.data
            }
          }
          this.$emit('drawLotsSaveSuccess', this.drawLots)
          this.$toast('保存成功');
          this.showPop = false
          setTimeout(()=> {
            this.isClike = true
          },1500)
        }).catch(err => {
          this.$toast(err[0].message);
          this.isClike = true
        })
      }
    },
    cancel() {
      this.showPop = false
      this.isClike = true
    },
    getDictData(typeCode) {
      this.$api.drawlots.getDictData(typeCode)
        .then(res =>{
          if (typeCode == 'draw_lots_type') {
            this.drawLotstype = res.data
          }else if (typeCode == 'draw_lots_desc') {
            this.drawLotsDesc = res.data
          }
        })
    }
  },
  mounted() {
    this.getDictData('draw_lots_type')
  },
}
</script>

<style lang="stylus" scoped>
.content {
  .tips {
    font-size: 10px;
    color: #bbb;
    margin: 6px 0 6px 10px;
  }
  .serial-no {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #606266;
    font-weight: 600;
    height: 30px;
    margin: 0 15px;
    .replace {
      color: #ff6b31;
    }
  }
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff;
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
  .h5-cropper {
    position: absolute;
    left: -1000px;
    background: red;
  }
}
</style>